import { render, staticRenderFns } from "./FraseElectro.vue?vue&type=template&id=df47e1d6&"
import script from "./FraseElectro.vue?vue&type=script&lang=js&"
export * from "./FraseElectro.vue?vue&type=script&lang=js&"
import style0 from "./FraseElectro.vue?vue&type=style&index=0&id=df47e1d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports